module.exports = __webpack_public_path__ + "static/media/dj.63e20123.svg";